import styled from 'styled-components'

import { Box } from '@careguide/theme'

type IconWithTextProps = {
  iconUrl?: string
  text: string
  iconDimension?: { width?: string; height?: string }
  iconAlt?: string
}

const IconWithText = (props: IconWithTextProps) => {
  const { iconUrl, iconDimension, text, iconAlt } = props

  return (
    <Box display='flex' flexDirection='row'>
      {iconUrl && (
        <Box aria-hidden as='img' mr='.5rem' src={iconUrl} alt={iconAlt} {...iconDimension} />
      )}
      <StyledText aria-label={props['aria-label']}>{text}</StyledText>
    </Box>
  )
}

const StyledText = styled.span`
  white-space: pre-wrap;
`

export default IconWithText
